import { useEffect, useRef } from 'react';

/**
 * Calls `callback` after `delay` ms of inactivity on `value` change.
 * The callback is NOT called on the initial mount.
 */
export function useDebounce(value: string, callback: () => void, delay = 400) {
  const isFirst = useRef(true);
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    if (isFirst.current) { isFirst.current = false; return; }
    const id = setTimeout(() => cbRef.current(), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
}
